<script>
import LKPublicationsFormdataReport from '@/views/LKPublications/formdata/LKPublicationsFormdataReport.vue'
import { PassportApi } from '@/api/resources'

export default {
  extends: LKPublicationsFormdataReport,
  props: {
    requestParams: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    async getOrCreateReport() {
      const api = new PassportApi()
      try {
        this.isLoadingData = true
        const { data } = this.params.isList
          ? await api.downloadUrl(this.requestParams)
          : await api.downloadPassportById(this.params.passportId)
        if (data.id) {
          this.checkStatus(data.id)
        }
      } catch (e) {
        this.$notice.errors(e)
      } finally {
        this.isLoadingData = false
      }
    },
  },
}
</script>
